import { X } from "lucide-react";
import { Dispatch, SetStateAction, memo } from "react";

interface ConfirmationModalProps {
  title: string;
  message: string;
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  handleOnClick: (e: string) => void;
  isDeleteModal?: boolean;
  backdrop?: string;
}

const ConfirmationModal = (props: ConfirmationModalProps) => {
  const {
    show,
    setShow,
    title,
    message,
    handleOnClick,
    isDeleteModal,
    backdrop,
  } = props;

  const handleOnClickYes = (props: string) => {
    handleOnClick(props);
    setShow(false);
  };

  const handleOnClickNo = () => {
    handleOnClick("No");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${backdrop ? backdrop : "backdrop-blur-sm"}`}
      onClick={handleOnClickNo}
    >
      <div
        className={`bg-white dark:bg-[#1C1C2A] rounded-lg shadow-lg w-full p-6 relative max-w-[416px]`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white"
          onClick={handleOnClickNo}
        >
          <X className="w-5 h-5" />
        </button>

        {/* Modal Title */}
        <h2
          className="text-xl font-semibold mb-4"
          dangerouslySetInnerHTML={{ __html: title }}
        />

        {/* Modal Message */}
        <div
          className="text-gray-700 mb-6  dark:text-gray-400"
          dangerouslySetInnerHTML={{ __html: message }}
        />

        {/* Modal Actions */}
        {isDeleteModal ? (
          <div className="flex justify-end space-x-3">
            <button
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              onClick={() => handleOnClickYes("Delete")}
            >
              Delete
            </button>
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={handleOnClickNo}
            >
              Cancel
            </button>
          </div>
        ) : (
          <div className="flex justify-end space-x-3">
            <button
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              onClick={handleOnClickNo}
            >
              No
            </button>
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={() => handleOnClickYes("Yes")}
            >
              Yes
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(ConfirmationModal);
